import React, { useMemo } from 'react'
import { Pagination } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { Preloader } from '../../../../components/UI'
import TournamentItem from '../../../../components/list-items/components/tournamentItem'
import { useFollowedTournaments } from './hooks/useFollowedTournaments'

import styles from './styles.module.scss'

export const TournamentsList = () => {
  const { isLoading, tournamentList, handleChangeTournaments } =
    useFollowedTournaments()

  const tournaments = useMemo(
    () => tournamentList?.follows || [],
    [tournamentList?.follows]
  )

  const tournamentItems = useMemo(() => {
    return tournaments.map(items => (
      <li key={items.id}>
        <TournamentItem {...items} />
      </li>
    ))
  }, [tournaments])

  const hasTournaments = useMemo(
    () => tournaments.length > 0,
    [tournaments.length]
  )

  const paginationProps = useMemo(
    () => ({
      classes: { ul: styles.pagination },
      count: tournamentList?.paginator?.lastPage,
      page: tournamentList?.paginator?.currentPage,
      onChange: handleChangeTournaments,
      variant: 'outlined',
    }),
    [
      tournamentList?.paginator?.lastPage,
      tournamentList?.paginator?.currentPage,
      handleChangeTournaments,
    ]
  )

  const shouldShowPagination = useMemo(() => {
    return (
      !tournamentList?.paginator?.hasNextPage ||
      tournamentList?.follows?.length > 9
    )
  }, [tournamentList?.paginator?.hasNextPage, tournamentList?.follows?.length])

  if (isLoading) {
    return <Preloader />
  }

  return (
    <section className={styles.calendarList}>
      {!hasTournaments && (
        <div className='empty-data'>
          <FormattedMessage id='calendar.noTournaments' />
        </div>
      )}

      <article>
        <ul>{tournamentItems}</ul>
      </article>

      {shouldShowPagination && (
        <div className={styles.paginatorWrapper}>
          <Pagination {...paginationProps} />
        </div>
      )}
    </section>
  )
}

export default TournamentsList
